import { AiModal } from '@aigc/components';
import { useOverlayRef } from '@aigc/overlay-hook';
import type { Notification } from '@novu/react';
import DOMPurify from 'dompurify';
import { useMemo } from 'react';
import { RichText } from './rich-text';

export function AnnouncementDetailModal(props: { data: Notification }) {
  const overlay_ref = useOverlayRef();
  const sanitized_body = useMemo(
    () => DOMPurify.sanitize(props.data.body),
    [props.data.body],
  );

  return (
    <AiModal
      title={props.data.subject}
      width={800}
      onCancel={() => overlay_ref.close()}
      footer={null}
    >
      <RichText value={sanitized_body} inline readonly />
    </AiModal>
  );
}
